import React, { useEffect } from "react";
import { Form, DatePicker, notification, Typography } from "antd";
import dayjs from "../../utils/day";
import log from "../../utils/log";

const { Title, Text } = Typography;


const SingleDatePicker = ({
  state = {},
  style,
  minDate = dayjs(),
  maxDate,
  allowClear = false,
  occupiedDates = [],
  setWarningMessage = () => {}, // Accept setWarningMessage function
}) => {
  const { data, form, rules, onChange, keyName } = state;

  const handleDateChange = (value) => {
    if (!value) return;

    // Set value to the end of the day for proper storage in DB
    const selectedDate = value.endOf("day");

    // Check if the selected date overlaps with any occupied dates
    const isOverlapping = occupiedDates.some(({ start, end }) => {
      const startDate = dayjs(start);
      const endDate = dayjs(end);
      return selectedDate.isBetween(startDate, endDate, null, "[]");
    });

    if (isOverlapping) {
      notification.warning({
        message: "Date Overlap",
        description: "This date is already occupied. Please select another date.",
      });
      form.setFieldsValue({
        [keyName]: undefined,
      });
      return;
    } else {
      setWarningMessage(""); // Clear warning if no overlap
    }

    onChange(selectedDate.toISOString());
  };

  // Disable dates that overlap with the occupied date ranges
  const isDateOccupied = (current) => {
    return occupiedDates.some(({ start, end }) => {
      return current.isBetween(start, end, null, "[]");
    });
  };

  // Function to disable dates outside the allowed range
  const disableDate = (current) => {
    if (!current) return false;
    return current.isBefore(minDate, "day") || (maxDate && current.isAfter(maxDate, "day")) || isDateOccupied(current);
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        [keyName]: dayjs(data),
      });
    } else {
      form.setFieldsValue({
        [keyName]: undefined,
      });
    }
  }, [data, form, keyName]);

  return (
    <Form form={form} style={{ width: "100%" }}>
      <Form.Item name={keyName} rules={rules}>
        <DatePicker
          size={"large"}
          style={style}
          allowClear={allowClear}
          value={data ? dayjs(data) : undefined}
          onChange={handleDateChange}
          disabledDate={disableDate}
        />
      </Form.Item>
    </Form>
  );
};

export default SingleDatePicker;
